<script setup lang="ts">
const { assistantSettings } = useAssistantSettingsStore();

const {
  enabled = true,
  showAfter = 10,
  hideAfter = 20,
} = defineProps<{
  enabled?: boolean;
  showAfter?: number;
  hideAfter?: number;
}>();

const visible = ref(false);

const showMessage = () => {
  visible.value = true;
};

const hideMessage = () => {
  visible.value = false;
};

const showMessageTimeout = ref();
const hideMessageTimeout = ref();

const isEnabled = computed(
  () => enabled && assistantSettings.text.conversation_starter,
);

const startTimers = () => {
  showMessageTimeout.value = window.setTimeout(showMessage, showAfter * 1000);
  hideMessageTimeout.value = window.setTimeout(hideMessage, hideAfter * 1000);
};

const clearTimers = () => {
  window.clearTimeout(showMessageTimeout.value);
  window.clearTimeout(hideMessageTimeout.value);
};

watch(
  () => isEnabled,
  (value) => {
    if (value) {
      startTimers();
    } else {
      clearTimers();
    }
  },
  { immediate: true },
);

// Cleanup when component is destroyed
onBeforeUnmount(() => {
  clearTimers();
});
</script>

<template>
  <Transition>
    <div v-if="isEnabled" v-show="visible" class="widget-button-message">
      {{ assistantSettings.text.conversation_starter }}
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
.widget-button-message {
  display: flex;
  flex-direction: column;
  width: auto;
  max-width: 256px;
  min-height: 1em;
  gap: 1em;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.25);
  border-radius: var(--main-border-radius);
  border-radius: 10px;
  background-color: var(--chat-bubble-assistant-background-color);
  color: var(--chat-bubble-assistant-text-color);
  font-size: 0.9em;
  scale: 1;
  transform-origin: bottom right;
  opacity: 1;
  pointer-events: all;
  padding: 0.75em;

  &.v-enter-active,
  &.v-leave-active {
    transition:
      opacity 100ms ease,
      scale 300ms cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  &.v-enter-from,
  &.v-leave-to {
    scale: 0.5;
    opacity: 0;
    transition:
      opacity 200ms ease-in,
      scale 200ms ease-in;
  }
}
</style>
